exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".igx-avatar,.igx-avatar--icon,.igx-avatar--image,.igx-avatar--large,.igx-avatar--medium,.igx-avatar--rounded,.igx-avatar--small{display:flex;justify-content:center;align-items:center;position:relative;pointer-events:none}.igx-avatar--rounded{border-radius:50%}.igx-avatar--small{width:2.5em;height:2.5em}.igx-avatar--medium{width:4em;height:4em}.igx-avatar--large{width:5.5em;height:5.5em}.igx-avatar--icon{background-color:rgba(0,0,0,.26)}.igx-avatar--image{background-color:transparent!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./node_modules/sass-loader/lib/loader.js!./src/avatar/avatar.component.scss
// module id = 111
// module chunks = 0 1